/*
 * @Author: Teemo Ding
 * @Date: 2021-10-18 17:09:42
 * @LastEditTime: 2022-06-10 14:11:47
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/index.tsx
 */

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CommonHeader from '@/src/components/CommonHeader';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import {
  request_authorizeCallback,
  request_generateAuthUrl,
  // request_bind,
  request_landingPage,
  request_unAuthorizeCallback,
  request_update,
  request_uploadCodeVersion,
} from '@/src/request/salesChannel/setting/miniProgramSetting';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { MissingPageType } from '@/src/types/common/domain';
import { Status } from '@/src/types/common/miniProgram';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import { get } from 'lodash';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import UploadCodeVersion from './Components/UploadCodeVersion';
import MiniProgramBinding from './MiniProgramBinding';
import MiniProgramCodeReview from './MiniProgramCodeReview';
import MiniProgramMissingPageRedirection from './MiniProgramMissingPageRedirection';
import MiniProgramPreview from './MiniProgramPreview';
import MiniProgramRegistrationEntity from './MiniProgramRegistrationEntity';
import MiniProgramVersionRelease from './MiniProgramVersionRelease';
import MiniProgramWebviewDomainName from './MiniProgramWebviewDomainName';
import css from './css.module.less';

const permissions = (uuid: string) => {
  const edit_Mini_program_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelMiniProgramSetting,
        operation: EnumOperation.edit_Mini_program_setting,
        uuid,
      }),
    ],
  });

  const view_Mini_program_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelMiniProgramSetting,
        operation: EnumOperation.view_Mini_program_settings,
        uuid,
      }),
    ],
  });

  return {
    edit_Mini_program_setting,
    view_Mini_program_settings,
  };
};

const SalesChannelMiniProgramSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const [registeredUnderChina, setRegisteredUnderChina] = useState(false);
  const params: any = useParams();
  const history = useHistory();
  const m: any = useLocation();
  const query = qs.parse(m.search);
  const { uuid: salesChannelUuid } = params;
  const { edit_Mini_program_setting, view_Mini_program_settings } =
    permissions(salesChannelUuid);
  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelSettings.config.miniProgramSetting'),
  });
  const [webViewDomains, setWebViewDomains] = React.useState(null);
  const {
    loading: landingPageLoading,
    run: runLandingPage,
    data: landingPageData,
  } = useRequest(() => request_landingPage(salesChannelUuid), {
    ready: !!view_Mini_program_settings,
    onSuccess: (data) => {
      const webViewDomains = get(data, 'miniProgram.webViewDomains');
      setWebViewDomains(webViewDomains);
      setRegisteredUnderChina((data.miniProgram || {}).registeredUnderChina);
    },
  });
  const {
    miniProgram = {},
    preview = null,
    review = null,
    releases = [],
    missingPageRedirectionSetting = {},
  } = landingPageData || {};
  const missingPageRedirections = (
    missingPageRedirectionSetting.missingPageRedirections || []
  ).filter((item) => item.missingPageType !== MissingPageType.UrlNotFound);

  const { run: runGenerateAuthUrl } = useRequest(
    () => request_generateAuthUrl(salesChannelUuid),
    {
      manual: true,
      ready: !!edit_Mini_program_setting,
      onSuccess: (data) => {
        // boundProgramSuccess();
        //TODO跳转到绑定微信第三方页面处理
        window.location.href = data.data;
      },
    },
  );

  const { run: runUploadCodeVersion } = useRequest(
    (data) => request_uploadCodeVersion(data),
    {
      manual: true,
      ready: !!edit_Mini_program_setting,
      onSuccess: (data = {}) => {
        const { status = '' } = data;
        if (status === Status.Rejected) {
          uploadCodeVersionError();
        } else {
          runLandingPage();
          onCancel();
        }
        //TODO失败处理
      },
    },
  );
  const { run: _request_unAuthorizeCallback } = useRequest(
    () => request_unAuthorizeCallback((miniProgram || {}).uuid),
    {
      manual: true,
      ready: !!edit_Mini_program_setting,
      onSuccess: (_, params: any) => {
        runLandingPage();
      },
    },
  );

  const { run: _request_update } = useRequest(
    (data) =>
      request_update({
        uuid: (miniProgram || {}).uuid,
        registeredUnderChina: data,
      }),
    {
      manual: true,
      ready: !!edit_Mini_program_setting,
      onSuccess: (res, params: any) => {
        setRegisteredUnderChina(params[0]);
      },
    },
  );
  useEffect(() => {
    if (query.auth_code && Object.keys(i18n).length) {
      const data = query;
      request_authorizeCallback(salesChannelUuid, data).then((data) => {
        if (data.hasError) {
          boundProgramError();
        } else {
          boundProgramSuccess();
          runLandingPage();
        }
      });
    }
    //TODO bind跳转回页面处理
  }, [i18n]);

  const onCancel = () => {
    setShowModal(false);
  };

  const boundModalCancel = () => {
    setShowModal(false);
    history.replace(
      `/salesChannel/setting/miniProgramSetting/${salesChannelUuid}`,
    );
  };

  //TODO bind返回成功处理
  const boundProgramSuccess = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'salesChannelMiniProgramSettings.index.boundMiniProgramSuccessful',
      ),
    );
    setModalContent(
      <div>
        <p className={css.boundProgramSuccess}>
          {getI18n(
            'salesChannelMiniProgramSettings.index.boundMiniProgramSuccessfulContent',
          )}
        </p>
        <ModalFooter
          onOk={boundModalCancel}
          okText={getI18n('general.antd.Uploader.ok')}
        />
      </div>,
    );
  };

  //TODO bind返回失败处理
  const boundProgramError = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>Failed To Bind Mini Program</ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => boundModalCancel}
        errorText='Failed to bind your Mini Program to this sales channel.'
        okText='OK'
      />,
    );
  };

  const uploadCodeVersionError = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>Failed To Upload Code Version</ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => setShowModal(false)}
        errorText='Failed to upload code version. Please try again.'
        okText='OK'
      />,
    );
  };

  const onGoBackClick = () => {
    history.push(`/salesChannel/settings/${salesChannelUuid}`);
  };

  const handleUploadCodeVersion = () => {
    setShowModal(true);
    setModalTitle('Upload Code Version');
    setModalContent(
      <UploadCodeVersion
        onCancel={onCancel}
        onUploadCodeVersion={runUploadCodeVersion}
        miniProgramUuid={(miniProgram || {}).uuid || ''}
      />,
    );
  };

  const isBind = (miniProgram || {}).uuid;

  return (
    <Spin spinning={breadCrumbLoading || landingPageLoading}>
      <CommonHeader
        breadcrumbData={breadcrumbData}
        onGoBackClick={onGoBackClick}
      />
      <Spin spinning={landingPageLoading}>
        {view_Mini_program_settings ? (
          <div className={css.formClass}>
            <MiniProgramBinding
              miniProgram={miniProgram}
              onBind={runGenerateAuthUrl}
              unBind={_request_unAuthorizeCallback}
              disabled={!edit_Mini_program_setting}
            />
            {isBind && (
              <MiniProgramRegistrationEntity
                value={registeredUnderChina}
                onChange={_request_update}
                disabled={!edit_Mini_program_setting}
              />
            )}
            <MiniProgramPreview
              preview={preview}
              onUploadCodeVersion={handleUploadCodeVersion}
              runLandingPage={runLandingPage}
              setShowModal={setShowModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
              submitCodeVersionConfirm={
                get(review, 'status', '') == Status.Passed
              }
              disabled={!edit_Mini_program_setting}
            />
            <MiniProgramCodeReview
              review={review}
              setShowModal={setShowModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
              runLandingPage={runLandingPage}
              disabled={!edit_Mini_program_setting}
            />
            <MiniProgramVersionRelease releases={releases} />
            {!landingPageLoading && (
              <MiniProgramWebviewDomainName
                isBind={isBind}
                miniProgramUuid={(miniProgram || {}).uuid || ''}
                iniData={webViewDomains}
              />
            )}
            {missingPageRedirections?.length ? (
              <MiniProgramMissingPageRedirection
                disabled={!edit_Mini_program_setting}
                missingPageRedirections={missingPageRedirections}
              />
            ) : null}
          </div>
        ) : null}
      </Spin>
    </Spin>
  );
};

export default ModalHoc(SalesChannelMiniProgramSetting);
